import { render, staticRenderFns } from "./news2.vue?vue&type=template&id=e3ef48b6&scoped=true&"
import script from "./news2.vue?vue&type=script&lang=js&"
export * from "./news2.vue?vue&type=script&lang=js&"
import style0 from "./news2.vue?vue&type=style&index=0&id=e3ef48b6&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3ef48b6",
  null
  
)

export default component.exports